import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { useT } from "@/i18n";

export default function PageHeader({ title, subtitle, image, crumb }) {
  const t = useT();
  return (
    <section className="relative bg-navy-900 overflow-hidden">
      {image && (
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/90 to-navy-900/70" />
        </div>
      )}
      <div className="container-kyt relative pt-[150px] md:pt-[180px] pb-16 md:pb-20">
        <Reveal>
          <nav className="flex items-center gap-2 font-mono text-[11px] tracking-[0.14em] uppercase text-white/45 mb-5">
            <Link to="/" className="hover:text-white transition-colors">{t("pageheader.home")}</Link>
            <span>/</span>
            <span className="text-white/80">{crumb || title}</span>
          </nav>
        </Reveal>
        <Reveal delay={80}>
          <h1 className="font-display text-[2.6rem] sm:text-6xl font-bold text-white tracking-tight leading-[1.02]">
            {title}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={140}>
            <p className="mt-6 text-white/60 text-lg max-w-2xl leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
